import React, { useState, useEffect } from "react";
import AsyncSelect from "react-select/async";
import { notificarError } from "../Almacenes/AlmacenNotify";

export default function ProductFinder({ onChoose, tiposTransaccion }) {
    const [product, setProduct] = useState(null);
    const [tipoTransaccion, setTipoTransaccion] = useState(null);
    
    useEffect(() => {
        if (tiposTransaccion && tiposTransaccion.length > 0 && !tipoTransaccion) {
            setTipoTransaccion(tiposTransaccion[0].IdTipoTransaccionAlmacen);
        }
    }, [tiposTransaccion, tipoTransaccion]);

    const searchProducts = (search) => {
        return new Promise((resolve, reject) => {
            fetch(`/api/ordenescompra/listprod/382?tipoDoc=1&search=${search}`)
                .then(r => r.json())
                .then(prods => resolve(prods))
                .catch(reject)
        })
    }

    const onAgregarProducto = () => {
        if (!product || !tipoTransaccion) {
            notificarError("El producto y el tipo de transacción son requeridos.");
            return;
        }

        onChoose({...product, idTipoTransaccion: tipoTransaccion});
    }

    return <>
        <div className="form-group">
            <label>Buscar producto</label>
            <AsyncSelect
                isClearable={true}
                onChange={p => setProduct(p)}
                value={product}
                loadOptions={searchProducts}
                placeholder="Buscar producto"
            />
        </div>
        <div className="form-group">
            <label>Tipo de transacción</label>
            <select className="form-control" onChange={e => setTipoTransaccion(e.target.value)} value={tipoTransaccion}>
                {tiposTransaccion.map(t => (
                    <option key={t.IdTipoTransaccionAlmacen} value={t.IdTipoTransaccionAlmacen}>{t.Descripcion}</option>
                ))}
            </select>
        </div>
        <div className="d-flex justify-content-end">
            <button type="button" className="btn btn-info" onClick={onAgregarProducto}>Agregar</button>
        </div>
    </>;
}